import React, { FunctionComponent, SVGProps } from "react";

export const CalendarIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="26"
      viewBox="0 0 24 26"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6 .25c.41421 0 .75.335786.75.75v1.25h10.5V1c0-.414214.3358-.75.75-.75s.75.335786.75.75v1.25H22c.9665 0 1.75.7835 1.75 1.75v20c0 .9665-.7835 1.75-1.75 1.75H2c-.9665 0-1.75-.7835-1.75-1.75V4c0-.9665.7835-1.75 1.75-1.75h3.25V1c0-.414214.33579-.75.75-.75Zm-.75 3.5H2c-.13807 0-.25.11193-.25.25v4.25h20.5V4c0-.13807-.1119-.25-.25-.25h-3.25V5c0 .41421-.3358.75-.75.75s-.75-.33579-.75-.75V3.75H6.75V5c0 .41421-.33579.75-.75.75s-.75-.33579-.75-.75V3.75Zm17 6H1.75V24c0 .1381.11193.25.25.25h20c.1381 0 .25-.1119.25-.25V9.75Zm-15.5 4.2496c0-.4142.33579-.75.75-.75H11c.2883 0 .5511.1652.676.4251.1249.2598.0898.5683-.0903.7934l-1.2863 1.6078c.3974.2131.7363.5206.9869.8955.2513.3759.406.808.4504 1.258.0444.45-.0228.904-.1957 1.3218-.1729.4178-.4462.7865-.7956 1.0735-.3494.287-.76423.4834-1.20767.5718-.44344.0884-.90184.0661-1.33461-.0649-.43277-.131-.82655-.3668-1.14648-.6863-.29307-.2927-.29336-.7676-.00064-1.0606.29271-.2931.76758-.2934 1.06066-.0007.14542.1452.32441.2524.52112.312.19672.0595.40508.0696.60664.0295.20157-.0402.39011-.1295.54894-.26.15883-.1304.28304-.298.36164-.4879s.1091-.3963.089-.6008c-.0202-.2046-.0906-.401-.2048-.5718-.11418-.1709-.26877-.311-.45004-.4079-.18127-.0968-.38363-.1475-.58916-.1475-.2883 0-.55109-.1653-.67598-.4251-.12489-.2599-.08977-.5683.09033-.7934l1.02518-1.2815H7.5c-.41421 0-.75-.3358-.75-.75Zm9.5854-.6708c.2541.127.4146.3867.4146.6708v6.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-5l-.8.6c-.3314.2486-.8015.1814-1.05-.15-.2485-.3313-.1814-.8014.15-1.05l2-1.5c.2273-.1704.5313-.1978.7854-.0708Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
